import React from 'react';
import { getBallotOptionLabel, getBallotOptionImage } from './VoteTypeUtils.js'

export const VoteMultiSelect = ({ options, hasVoted, onOptionsUpdate, group }) => {
    const handleSelect = (event) => {
        // Selected id clicked
        const selectedId = parseInt(event.target.value)

        // Clone the array
        const multiOptions = [...options]

        // Count current selections
        let selectionCount = 0;
        for (let option of multiOptions) {
            selectionCount += option.score;
        }

        // Clone and update each one
        for (let i = 0; i < multiOptions.length; i++) {
            multiOptions[i] = { ...multiOptions[i] }
            if (multiOptions[i].ballotOptionId === selectedId) {
                // Selecting and we havent reached max votes yet
                if (multiOptions[i].score !== 1 && selectionCount < group.maximumVotes) {
                    multiOptions[i].score = 1;
                }
                // Deselecting
                else if (multiOptions[i].score === 1) {
                    multiOptions[i].score = 0;
                }
            }
        }

        // Notify update
        onOptionsUpdate(multiOptions)
    }

    return (
        <React.Fragment>
            {options.map((option) =>
                <div key={option.ballotOptionId} className="mb-4 flex items-start">
                    {getBallotOptionImage(group, option)}
                    <input type="checkbox"
                        id={option.ballotOptionName}
                        value={option.ballotOptionId}
                        disabled={hasVoted}
                        checked={option.score > 0}
                        onChange={handleSelect} />
                    <label htmlFor={option.ballotOptionName}
                        className="cursor-pointer disabled:cursor-default flex-1">{getBallotOptionLabel(group, option)}</label>
                </div>
            )}
        </React.Fragment>
    );
}